export const DEFAULT_RSS_FEED_URL = "https://d1gmlke7klm7mg.cloudfront.net/rss/feeds"

export const DevActionTypes = {
    SET_IS_DEV_MODE_ENABLED: "@@dev/SET_IS_DEV_MODE_ENABLED",
    SET_IS_NEW_UI_ENABLED: "@@dev/SET_IS_NEW_UI_ENABLED",
    SET_IS_INTERNAL_MODE_ENABLED: "@@dev/SET_IS_INTERNAL_MODE_ENABLED",
    SET_IS_ALPHA_MODE_ENABLED: "@@dev/SET_IS_ALPHA_MODE_ENABLED",
    SET_IS_FORCE_FREE_MODE: "@@dev/SET_IS_FORCE_FREE_MODE",
    SET_IS_TESTING_INSTRUMENT_SETTINGS: "@@dev/SET_IS_TESTING_INSTRUMENT_SETTINGS",
    SET_RSS_FEED_URL: "@@dev/SET_RSS_FEED_URL"

}

export interface DevState {
    isDevModeEnabled: boolean
    isNewUIEnabled: boolean
    isInternalModeEnabled: boolean
    isAlphaModeEnabled: boolean
    isDebugFreeMode: boolean
    isTestingInstrumentSettings: boolean
    rssFeedUrl: string
}
